import { useCan } from "@refinedev/core";

export default function useIsAdmin() {
  // todo : refactor with better ACL check with backend
  // workaround for now using media_generation_steps access usually only for admin
  const { data: isAdmin } = useCan({
    resource: "media_generation_steps",
    action: "show",
  });
  return isAdmin?.can ?? false;
}
